import styles from './Input.module.scss';
import { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  label: string;
  addon?: ReactNode;
}

export function Input(props: Props) {
  return (
    <div className={styles['root']}>
      <div className={styles['top']}>
        <div className={styles['label']}>{props.label}</div>
        {props.addon && <div className={styles['addon']}>{props.addon}</div>}
      </div>
      <div>{props.children}</div>
    </div>
  );
}
